import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useEffectOnce, useInterval } from "utils/customHooks/genericHooks";
import { getTokenInfo } from "contexts/AuthManager/Auth";
import { updateCustomerJson } from "providers/GlobalStateProvider";
import { useDispatch } from "react-redux";
import { CUSTOMER_JSON_POLL_INTERVAL } from "constants/intervals";
import { useTransition } from "react";
import { useFlightConfig } from "./FlightConfig/useFlightConfig";
import { INVALID_CUSTOMERS } from "constants/constants";

/** fetch the customer json once we have the ckey */
export const CustomerInfoJsonGetter = () => {
  const ckey = useCustomerKey();
  const dispatch = useDispatch();
  const [, startTransition] = useTransition();
  const fetchAndDispatchCustomerJson = () => {
    if (!ckey || INVALID_CUSTOMERS.includes(ckey)) {
      return;
    }
    fetchCustomerJson(ckey).then(data => {
      startTransition(() => {
        dispatch(updateCustomerJson(data));
      });
    });
  };

  // fetch once on mount, ASAP: as soon as we get the ckey
  useEffectOnce({
    callback: fetchAndDispatchCustomerJson,
    shouldRun: Boolean(ckey) && !INVALID_CUSTOMERS.includes(ckey),
    dependencies: [ckey],
  });
  const [
    {
      general: { multiplyNetworkRequestIntervals },
    },
  ] = useFlightConfig();

  // fetch again every 5 minutes, just in case
  useInterval({
    callback: fetchAndDispatchCustomerJson,
    immediate: false,
    delay: CUSTOMER_JSON_POLL_INTERVAL * multiplyNetworkRequestIntervals,
  });

  return null;
};

export function fetchCustomerJson(ckey: string) {
  return fetch(
    `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/resource/customerInfo.json`,
    {
      method: "get",
      headers: new Headers({
        Authorization: `Bearer ${getTokenInfo().idToken}`,
      }),
    }
  )
    .then(resp => resp.json())
    .catch(err => {
      console.log("CustomerJsonGetter error:", err);
    });
}
